/** Select the first populated revision in API order without guessing when a count is unavailable. */
export async function firstRevisionWithWorks(
  revisions: readonly {id: string}[],
  readCount: (revisionId: string) => Promise<unknown>,
): Promise<string | undefined> {
  for (const revision of revisions) {
    const count = await readCount(revision.id);
    if (typeof count !== "number" || !Number.isSafeInteger(count) || count < 0) {
      throw new Error("Не удалось определить число работ для выбора комплекта. Повторите загрузку.");
    }
    if (count > 0) return revision.id;
  }
  return revisions[0]?.id;
}
